module.exports = __webpack_public_path__ + "media/highclass/example-4-f7ded985.webp";